module.exports = __webpack_public_path__ + "static/media/twitter-icon.e854f14d.svg";